import { motion } from "framer-motion";

export function Hero() {
  return (
    <section className="relative overflow-hidden bg-gray-900 min-h-[80vh] flex items-center justify-center py-16">
      <div className="absolute inset-0 flex flex-col md:flex-row">
        {/* Salt Image */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="relative w-full h-1/2 md:h-full md:w-1/2 overflow-hidden border-b-8 md:border-b-0 md:border-r-4 border-salt-orange"
        >
          <img
            alt="Heavy loader moving de-icing salt"
            loading="eager"
            fetchPriority="high"
            className="w-full h-full object-cover opacity-50 grayscale hover:grayscale-0 transition-all duration-700"
            style={{ transform: "scale(1.15)" }}
            src="https://vibe.filesafe.space/1774883178162043817/assets/9350074a-34ee-49b3-a286-4cfc004317d0.png"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-salt-dark/95 via-transparent to-transparent"></div>
        </motion.div>
        {/* Plant Image */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="relative w-full h-1/2 md:h-full md:w-1/2 overflow-hidden border-t-8 md:border-t-0 md:border-l-4 border-plant-green"
        >
          <img
            alt="Premium wholesale nursery specimen trees"
            loading="eager"
            fetchPriority="high"
            className="w-full h-full object-cover opacity-50 grayscale hover:grayscale-0 transition-all duration-700"
            style={{ transform: "scale(1.15)" }}
            src="https://vibe.filesafe.space/1774883178162043817/assets/0d3f8d7b-5216-424c-b22d-c987bad8d48d.png"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-plant-green/95 via-transparent to-transparent"></div>
        </motion.div>
        <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-[2px] bg-gradient-to-b from-salt-orange via-salt-orange to-plant-lime z-20 -translate-x-1/2 shadow-[0_0_15px_rgba(139,195,74,0.3)]"></div>
      </div>

      <div className="relative z-30 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center flex flex-col items-center justify-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mb-8 relative inline-block"
        >
          <img
            src="https://vibe.filesafe.space/1774883178162043817/attachments/143fc069-80c1-443b-8bda-33476d8a66fb.png"
            alt="911 Sourcing Logo"
            className="h-48 sm:h-64 md:h-80 w-auto drop-shadow-2xl mx-auto"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="max-w-6xl mx-auto pt-4"
        >
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-black font-heading tracking-tight text-white mb-6 uppercase leading-[0.95] drop-shadow-2xl">
            <span className="block mb-2">Salt & Plant Sourcing.</span>
            <span className="text-white block drop-shadow-md">
              We Answer The Phone. Period.
            </span>
          </h1>
          <p className="max-w-3xl mx-auto text-base md:text-xl text-gray-100 mb-10 font-bold tracking-tight px-4 leading-relaxed drop-shadow-lg">
            Serving Kentucky, Ohio, Indiana, and Tennessee with over 15 years of
            experience in sourcing.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto px-4 w-full">
            <a
              className="group relative bg-salt-orange p-8 md:p-10 flex flex-col items-center justify-center transition-all hover:scale-[1.03] active:scale-95 shadow-2xl rounded-2xl border border-white/20"
              href="/salt-supply"
            >
              <span className="text-white font-black uppercase text-xl md:text-2xl tracking-widest">
                De-Icing Salt
              </span>
              <span className="text-white/90 text-[11px] font-bold uppercase mt-3 tracking-[0.2em]">
                Emergency Dispatch 24/7
              </span>
            </a>
            <a
              className="group relative bg-plant-green p-8 md:p-10 flex flex-col items-center justify-center transition-all hover:scale-[1.03] active:scale-95 shadow-2xl rounded-2xl border border-white/10"
              href="/plant-finder"
            >
              <span className="text-plant-lime font-black uppercase text-xl md:text-2xl tracking-widest">
                Plant Material
              </span>
              <span className="text-white/90 text-[11px] font-bold uppercase mt-3 tracking-[0.2em]">
                Specimen Tree & Plant Finder
              </span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
